import { render, staticRenderFns } from "./AlertRuleModal.vue?vue&type=template&id=5f1aed8e&"
import script from "./AlertRuleModal.vue?vue&type=script&lang=js&"
export * from "./AlertRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports